import api from './api';

export const userLoginApi = (credentials) => api()
  .post('/authentication', credentials);

export const userLogoutApi = () => api().delete('/authentication');
